import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  to?: string; // Optional target route
}

const BackButton = ({ to }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleGoBack}
      className="fixed top-6 left-6 z-[60] p-3 bg-white/10 backdrop-blur-sm rounded-lg text-white hover:bg-white/20 transition-all duration-300 shadow-lg border border-white/20"
      aria-label="Wróć do poprzedniej strony"
    >
      <ArrowLeft size={24} />
    </button>
  );
};

export default BackButton;